import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "addicon" }

import { computed } from "vue";
import { useRoute } from "vue-router"; // 导入 useRoute


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatorSidebar',
  setup(__props) {

const route = useRoute(); // 获取路由实例

// 计算当前激活路径
const activePath = computed(() => route.path);

const addDraftsUrl = computed(() => {
  return `/editor/create/drafts?v=1`;
});


return (_ctx: any,_cache: any) => {
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_House = _resolveComponent("House")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Postcard = _resolveComponent("Postcard")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, { class: "sidebar" }, {
    default: _withCtx(() => [
      _createElementVNode("a", {
        class: "creatorbtn btn-primary",
        href: addDraftsUrl.value,
        target: "_blank"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Edit)
            ]),
            _: 1
          })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "addtext" }, "发布新内容", -1))
      ], 8, _hoisted_1),
      _createVNode(_component_el_menu, {
        "default-active": activePath.value,
        router: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/creator/home" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_House)
                ]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "首页", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/creator/article" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DocumentCopy)
                ]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "内容", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/user/settings/avatar" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Avatar)
                ]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "用户头像", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/user/settings/profile" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Postcard)
                ]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "个人资料", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _: 1
  }))
}
}

})